import Axios from "axios";
import { createAiHttp } from "./aiHttp";

const aiHttp = createAiHttp();

class AnnexService {
  // ── Gestão de documentos ─────────────────────────────────────────────────

  RequestUploadUrl(contaId, filename, sizeBytes, description, category) {
    return aiHttp({
      url: "/annexes/upload-url",
      data: {
        conta_id: contaId,
        filename: filename,
        size_bytes: sizeBytes,
        description: description,
        category: category
      },
      method: "POST"
    });
  }

  UploadToS3(uploadUrl, file) {
    return Axios.put(uploadUrl, file, {
      headers: { "Content-Type": file.type }
    });
  }

  ConfirmUpload(annexId) {
    return aiHttp({
      url: "/annexes/" + annexId + "/confirm",
      method: "POST"
    });
  }

  ListAnnexes(contaId) {
    return aiHttp({
      url: "/annexes",
      params: { conta_id: contaId },
      method: "GET"
    });
  }

  GetAnnex(annexId) {
    return aiHttp({
      url: "/annexes/" + annexId,
      method: "GET"
    });
  }

  GetDownloadUrl(annexId) {
    return aiHttp({
      url: "/annexes/" + annexId + "/download-url",
      method: "GET"
    });
  }

  UpdateAnnex(annexId, data) {
    return aiHttp({
      url: "/annexes/" + annexId,
      data: data,
      method: "PATCH"
    });
  }

  DeleteAnnex(annexId) {
    return aiHttp({
      url: "/annexes/" + annexId,
      method: "DELETE"
    });
  }

  ReprocessAnnex(annexId) {
    return aiHttp({
      url: "/annexes/" + annexId + "/reprocess",
      method: "POST"
    });
  }

  // ── Pergunta e resposta (RAG) ────────────────────────────────────────────

  AskQuestion(contaId, question) {
    return aiHttp({
      url: "/annexes/qa/ask",
      data: { conta_id: contaId, question: question },
      method: "POST"
    });
  }

  ListQaMessages(contaId) {
    return aiHttp({
      url: "/annexes/qa/messages",
      params: { conta_id: contaId },
      method: "GET"
    });
  }
}

export default new AnnexService();
